import { TradingPanelOrder } from '@/components/orders/trading-panel-orders';

export default function Orders() {
    return <TradingPanelOrder />;
}
